// src/components/SignModal.tsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useSignEngagementLetterMutation } from 'app/services/engagementLetters';
import Button from 'Components/Buttons/Button';
interface SignModalProps {
  previewUrl: string;
  signUrl: string;
  engagementId: number;
  onClose: () => void;
  onSigned: () => void;
}

export const SignModal: React.FC<SignModalProps> = ({
  previewUrl,
  signUrl,
  engagementId,
  onClose,
  onSigned,
}) => {
  const [isLoading, setLoading] = React.useState(false);
  const [isSigned, setSigned] = React.useState(false);

  // when signed, notify parent
  useEffect(() => {
    if (isSigned) onSigned();
  }, [isSigned, onSigned]);

  const [signLetter] = useSignEngagementLetterMutation();

  const handleAgree = async () => {
    setLoading(true);
    try {
      // 1) Call the API
      await signLetter(engagementId).unwrap();
      // 2) Mark locally as signed
      setSigned(true);
      // 3) Fire the parent callback (if you need it)
      onSigned();
      // 4) Immediately reload the entire page so your UI re-reads
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // bust cache to show updated PDF after signing
  const src = isSigned ? `${previewUrl}?t=${Date.now()}` : previewUrl;

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 60,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
        style={{
          width: '90%',
          height: '90%',
          background: 'white',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <button onClick={onClose} style={{ alignSelf: 'flex-end', margin: 8 }}>
          ×
        </button>

        <iframe src={src} style={{ flex: 1, border: 0 }} />

        <div
          style={{
            padding: 16,
            display: 'flex',
            justifyContent: 'center',
            borderTop: '1px solid #eee',
          }}
        >
          {!isSigned ? (
            <Button
              theme="green-fill"
              className="px-6 py-3 text-base flex-none w-auto"
              type="button"
              onClick={handleAgree}
              isLoading={isLoading}
            >
              Review and Sign
            </Button>
          ) : (
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>
              ✅ Signed!
            </span>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};
